export const teachingPlatformApi = "/teachingPlatformService/api";
export const gatewayPrefix = "/operateService/api";
export const studyService = "/studyService/api";
